// import { useEffect } from "react";

// const LinkHandler = () => {
//   useEffect(() => {
//     const appLink = "https://play.google.com/store/apps/details?id=com.bizbrolly.orggenie&pcampaignid=web_share"; // your app scheme
//     const fallbackLink = "https://app.orggenie.com/"; // or main web app URL

//     const now = Date.now();
//     // Try opening the app
//     window.location.href = appLink;

//     // After a short delay, redirect to web if app not opened
//     setTimeout(() => {
//       if (Date.now() - now < 1500) {
//         window.location.href = fallbackLink;
//       }
//     }, 1000);
//   }, []);

//   return (
//     <div style={{ textAlign: "center", marginTop: "40vh" }}>
//       <h3>Opening app...</h3>
//       <p>If nothing happens, <a href="https://app.orggenie.com/">click here</a>.</p>
//     </div>
//   );
// };

// export default LinkHandler;


// import React, { useEffect } from "react";
 
// const OpenApp = () => {
//   useEffect(() => {
//     const appScheme = "orgapp://open?id=123"; // ← defined in your mobile app
//     const appLink = "https://play.google.com/store/apps/details?id=ccom.bizbrolly.orggenie";
//     const webFallback = "https://org.com/fallback"; // optional
 
//     // Try to open the app
//     window.location.href = appScheme;
 
//     // If app not installed, fallback after 2s
//     const timer = setTimeout(() => {
//       window.location.href = appLink; // or webFallback
//     }, 2000);
 
//     return () => clearTimeout(timer);
//   }, []);
 
//   return (
// <div style={{ textAlign: "center", marginTop: "100px" }}>
// <h2>Opening app...</h2>
// <p>
//         If it doesn't open,{" "}
// <a href="https://play.google.com/store/apps/details?id=com.org.app">
//           click here to download
// </a>.
// </p>
// </div>
//   );
// };
 
// export default OpenApp;

import React, { useCallback } from "react";

const ShareLink = () => {
  const shareUrl = "https://app.orggenie.com/open"; // your web route
  const appScheme = "orggenie://open"; // deep link handled by the mobile app
  const appLink = `https://app.orggenie.com/Announcement/Detail/b9fc9a10-b71c-4685-8e04-5c3b646ce964`;

  const handleShare = useCallback(async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Open OrgGenie App",
          text: "Check out OrgGenie — open this link on your device:",
          url: shareUrl,
        });
      } catch (err) {
        console.error("Share cancelled or failed:", err);
      }
    } else {
      // Fallback: copy to clipboard
      await navigator.clipboard.writeText(shareUrl);
      alert("Link copied to clipboard: " + shareUrl);
    }
  }, [shareUrl]);

  const handleOpen = useCallback(() => {
    const now = Date.now();
    window.location.href = appScheme;

    setTimeout(() => {
      if (Date.now() - now < 1500) {
        window.location.href = appLink;
      }
    }, 1000);
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "40vh" }}>
      <h3>OrgGenie App Link</h3>
      <button
        onClick={handleOpen}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          borderRadius: "8px",
          backgroundColor: "#007bff",
          color: "white",
          cursor: "pointer",
          marginRight: "10px",
        }}
      >
        Open App
      </button>

      <button
        onClick={handleShare}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          borderRadius: "8px",
          backgroundColor: "#28a745",
          color: "white",
          cursor: "pointer",
        }}
      >
        Share Link
      </button>
    </div>
  );
};

export default ShareLink;

